import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { AddExpenseApi, GetExpenseByOrderCategoryApi } from "./ExpenseActions";
import { useTranslation } from "react-i18next";
import { GetConstructionOrderApi, GetConstructionOrderWithIdApi, resetConstructionOrderData } from "../ConstructionOrder/ConstructionOrderAction";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { getProductData } from "../../AddDetails/AddProduct/Product.action";
import _ from "lodash";
import Select from "react-select";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import SendIcon from '@mui/icons-material/Send';
import SaveButton from '@mui/material/Button';


const AddExpense = (props) => {
    const { t } = useTranslation();
    const [orderId, setOrderId] = useState();
    const [orderName, setOrderName] = useState();
    const [orderCategoryId, setOrderCategoryId] = useState();
    const [orderCategoryName, setOrderCategoryName] = useState();
    const [inputFieldProduct, setInputFieldProduct] = useState([{
        productId: 0,
        productName: '',
        quantity: '',
        salePrice: 0,
        purchasePrice: 0,
        wholesalePrice: 0,
        totalSalePrice: 0,
    }]);
    const [inputFieldExtraService, setInputFieldExtraService] = useState([{
        description: '',
        quantity: 0,
        price: 0,
        totalPrice: 0,
    }]);



    const filteredInputFieldProduct = inputFieldProduct.filter(obj => {
        return !Object.values(obj).some(value => value === 0 || value === "");
    });
    const filteredInputFieldExtraService = inputFieldExtraService.filter(obj => {
        return !Object.values(obj).some(value => value === 0 || value === "");
    });
    const addCategory = (arr) => arr.map(item => ({ ...item, categoryId: orderCategoryId }));

    function SaveExpense() {
        props.AddExpenseApi({
            orderId: orderId,
            orderCategoryId: orderCategoryId,
            productExpenseData: addCategory(filteredInputFieldProduct),
            extraServiceExpenseData: addCategory(filteredInputFieldExtraService),
        },
            showSuccessAlert,
            showErrorAlert,
        );
        // reset redux data
        props.resetConstructionOrderData();
        // reset local state
        setOrderId("")
        setOrderName("")
        setOrderCategoryId("")
        setOrderCategoryName("")
        setInputFieldProduct([{
            productId: 0,
            productName: '',
            quantity: '',
            salePrice: 0,
            purchasePrice: 0,
            wholesalePrice: 0,
            totalSalePrice: 0,
        }]);
        setInputFieldExtraService([{
            description: '',
            quantity: 0,
            price: 0,
            totalPrice: 0,
        }]);
    }

    const handleChangeOrder = (selectedOption) => {
        setOrderId(selectedOption.value);
        setOrderName(selectedOption.label);
        props.GetConstructionOrderWithIdApi(selectedOption.value)
    };
    const GetOrderList = _.isEmpty(props.constructionOrderDataList) ? [] : props.constructionOrderDataList.map((x) => {
        let data = { value: x._id, label: `${x.sequenceNumber} / ${x.customerDetails.name}` };
        return data;
    });
    const handleChangeOrderCategory = (selectedOption) => {
        setOrderCategoryId(selectedOption.value);
        setOrderCategoryName(selectedOption.label);
        setInputFieldProduct([{
            productId: 0,
            productName: '',
            quantity: '',
            salePrice: 0,
            purchasePrice: 0,
            wholesalePrice: 0,
            totalSalePrice: 0,
        }]);
        setInputFieldExtraService([{
            description: '',
            quantity: 0,
            price: 0,
            totalPrice: 0,
        }]);

        props.GetExpenseByOrderCategoryApi(orderId, selectedOption.value);
    };
    const GetOrderCategoryList = _.isEmpty(props.constructionOrderWithIdData) ? [] : props.constructionOrderWithIdData.categories.map((x) => {
        let data = { value: x._id, label: x.name };
        return data;
    });


    const handleChangeProduct = (e, index, type) => {
        const list = [...inputFieldProduct];
        if (type === "intname") {
            const product = props.productDataList.find(p => p._id === e.value);
            list[index] = {
                ...list[index],
                productId: e.value,
                productName: e.label,
                purchasePrice: Number(product?.purchasePrice || 0),
                salePrice: Number(product?.salePrice || 0),
                wholesalePrice: Number(product?.wholesalePrice || 0),
            };
        }
        if (type === "intquantity") {
            const qty = Number(e.target.value);
            list[index].quantity = qty;
            list[index].totalSalePrice = Math.round((list[index].salePrice * qty) * 100) / 100;
        }

        setInputFieldProduct(list);
    };
    const filterProductList = props.productDataList?.filter((p) => p.category?._id === orderCategoryId) || [];
    const getProductList = filterProductList.map((p) => ({
        value: p._id,
        label: p.name
    }));
    const handleAddInputProduct = () => {
        setInputFieldProduct([...inputFieldProduct, {
            productId: 0,
            productName: '',
            quantity: '',
            salePrice: 0,
            purchasePrice: 0,
            wholesalePrice: 0,
            totalSalePrice: 0,
        }]);
    };
    const handleRemoveInputProduct = (index) => {
        const list = [...inputFieldProduct];
        list.splice(index, 1);
        setInputFieldProduct(list);
    };


    const handleChangeExtraService = (e, index, type) => {
        const list = [...inputFieldExtraService];
        if (type === "description") list[index]["description"] = e.target.value;
        if (type === "quantity") list[index]["quantity"] = Number(e.target.value);
        if (type === "price") list[index]["price"] = Number(e.target.value);
        if (type === 'price' || type === 'quantity') list[index]['totalPrice'] = Number(Math.round((list[index]['price'] * list[index]['quantity']) * 100) / 100);

        setInputFieldExtraService(list);
    };
    const handleAddInputExtraService = () => {
        setInputFieldExtraService([...inputFieldExtraService, {
            description: '',
            quantity: 0,
            price: 0,
            totalPrice: 0,
        }]);
    };
    const handleRemoveInputExtraService = (index) => {
        const list = [...inputFieldExtraService];
        list.splice(index, 1);
        setInputFieldExtraService(list);
    };


    useEffect(() => {
        props.setHeading("Add Expense")
        props.GetConstructionOrderApi()
        props.getProductData()
    }, []);

    useEffect(() => {
        if (!_.isEmpty(props.expenseByOrderCategoryData)) {
            setInputFieldProduct(
                props.expenseByOrderCategoryData.productExpenseData?.length ? props.expenseByOrderCategoryData.productExpenseData
                    : [{
                        productId: 0,
                        productName: '',
                        quantity: '',
                        salePrice: 0,
                        purchasePrice: 0,
                        wholesalePrice: 0,
                        totalSalePrice: 0,
                    }]
            );
            setInputFieldExtraService(
                props.expenseByOrderCategoryData.extraServiceExpenseData?.length ? props.expenseByOrderCategoryData.extraServiceExpenseData
                    : [{
                        description: '',
                        quantity: 0,
                        price: 0,
                        totalPrice: 0,
                    }]
            );
        }
    }, [props.expenseByOrderCategoryData]);


    return (<>
        {props.isAddingExpense || props.isFetchingConstructionOrder ? (
            <GlobalSpinner />
        ) : (
            <Container fluid>
                <Row>
                    <Col>
                        <Form.Group className="mb-3" controlId="garana">
                            <Form.Label><b>{t('SelectOrder')} *</b> </Form.Label>
                            <Select
                                placeholder="Select Order"
                                onChange={handleChangeOrder}
                                options={GetOrderList}
                            />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3" controlId="garana">
                            <Form.Label><b>{t('SelectCategories')} *</b> </Form.Label>
                            <Select
                                placeholder="Select Category"
                                onChange={handleChangeOrderCategory}
                                options={GetOrderCategoryList}
                            />
                        </Form.Group>
                    </Col>
                </Row>


                {/* {props.expenseByOrderCategoryData && (
                    <GlobalSpinner />
                )} */}
                {orderCategoryId && (<>
                    <Row style={{ marginTop: '30px' }}>
                        <Col>
                            <div style={{
                                border: "1px solid #e0e0e0",
                                borderRadius: "10px",
                                padding: "20px",
                                marginBottom: "15px",
                                background: "#fafafa"
                            }}>
                                <Col style={{
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "10px",
                                    padding: "10px",
                                    marginBottom: "15px",
                                    background: "#81abd3",
                                    width: 'fit-content',
                                    fontSize: '18px',
                                    fontWeight: 'bold'
                                }}> {t('Package')} </Col>

                                {inputFieldProduct.map((item, i) => (
                                    <React.Fragment key={i}>
                                        <Row>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label><b>{t('SelectProduct')} *</b></Form.Label>
                                                    <Select
                                                        placeholder="Select Product"
                                                        name="productId"
                                                        onChange={(e) => handleChangeProduct(e, i, "intname")}
                                                        options={getProductList}
                                                        isOptionDisabled={(option) => inputFieldProduct.some(x => x.productId === option.value)}
                                                        value={item.productId ? { value: item.productId, label: item.productName } : null}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label><b>{t('Quantity')} *</b></Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder="Add Quantity"
                                                        value={item.quantity}
                                                        onChange={(e) => handleChangeProduct(e, i, "intquantity")}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label><b>{t('SalesPrice')} *</b></Form.Label>
                                                    <Form.Control
                                                        disabled
                                                        type="number"
                                                        value={item.salePrice}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col>
                                                <Form.Group className="mb-3">
                                                    <Form.Label><b>Total Price</b></Form.Label>
                                                    <Form.Control
                                                        disabled
                                                        type="number"
                                                        value={item.totalSalePrice}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col style={{ display: "flex", alignItems: "center" }}>
                                                {inputFieldProduct.length - 1 === i && (
                                                    <Button
                                                        title="Add Product"
                                                        onClick={handleAddInputProduct}
                                                        style={{ marginRight: "5px" }}
                                                    >
                                                        <AddIcon />
                                                    </Button>
                                                )}
                                                {inputFieldProduct.length !== 1 && (
                                                    <Button
                                                        title="Remove Product"
                                                        onClick={() => handleRemoveInputProduct(i)}
                                                    >
                                                        <RemoveIcon />
                                                    </Button>
                                                )}
                                            </Col>
                                        </Row>
                                    </React.Fragment>
                                ))}
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col style={{ marginTop: '40px' }}>
                            <div style={{
                                border: "1px solid #e0e0e0",
                                borderRadius: "10px",
                                padding: "20px",
                                marginBottom: "15px",
                                background: "#fafafa"
                            }}>
                                <Col style={{
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "10px",
                                    padding: "10px",
                                    marginBottom: "15px",
                                    background: "#81abd3",
                                    width: 'fit-content',
                                    fontSize: '18px',
                                    fontWeight: 'bold'
                                }}> {t('Extra Service Expenses')} </Col>

                                {inputFieldExtraService.map((item, i) => (
                                    <React.Fragment key={i}>
                                        <Row>
                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label><b>{t('Description')} *</b></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Description"
                                                        value={item.description}
                                                        onChange={(e) => handleChangeExtraService(e, i, "description")}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={2}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label><b>{t('Quantity')} *</b></Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder="Quantity"
                                                        value={item.quantity}
                                                        onChange={(e) => handleChangeExtraService(e, i, "quantity")}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={2}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label><b>{t('UnitPrice')} *</b></Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        placeholder="Unit Price"
                                                        value={item.price}
                                                        onChange={(e) => handleChangeExtraService(e, i, "price")}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={3}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label><b>{t('TotalPrice')}</b></Form.Label>
                                                    <Form.Control
                                                        disabled
                                                        type="number"
                                                        value={item.totalPrice}
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={2} style={{ display: "flex", alignItems: "center" }}>
                                                {inputFieldExtraService.length - 1 === i && (
                                                    <Button
                                                        title="Add Extra Service"
                                                        onClick={handleAddInputExtraService}
                                                        style={{ marginRight: "5px" }}
                                                    >
                                                        <AddIcon />
                                                    </Button>
                                                )}

                                                {inputFieldExtraService.length !== 1 && (
                                                    <Button
                                                        title="Remove Extra Service"
                                                        onClick={() => handleRemoveInputExtraService(i)}
                                                    >
                                                        <RemoveIcon />
                                                    </Button>
                                                )}
                                            </Col>
                                        </Row>
                                    </React.Fragment>
                                ))}
                            </div>
                        </Col>
                    </Row>

                </>)}

                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                    {_.isEmpty(orderId) ? (
                        <SaveButton variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </SaveButton>
                    ) : (
                        <SaveButton variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveExpense}> SAVE </SaveButton>
                    )}
                </div>

            </Container>
        )}
    </>)
}

const mapDispatchToProps = (dispatch) => {
    return {
        AddExpenseApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddExpenseApi(data, showSuccessAlert, showErrorAlert)),
        GetConstructionOrderApi: () => dispatch(GetConstructionOrderApi()),
        GetConstructionOrderWithIdApi: (orderId) => dispatch(GetConstructionOrderWithIdApi(orderId)),
        getProductData: () => dispatch(getProductData()),
        resetConstructionOrderData: () => dispatch(resetConstructionOrderData()),
        setHeading: (data) => dispatch(setHeading(data)),
        GetExpenseByOrderCategoryApi: (orderId, categoryId) => dispatch(GetExpenseByOrderCategoryApi(orderId, categoryId)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingExpense: state.ExpenseReducer.isAddingExpense,
    isFetchingConstructionOrder: state.ConstructionOrderReducer.isFetchingConstructionOrder,
    constructionOrderDataList: state.ConstructionOrderReducer.constructionOrderDataList,
    isFetchingConstructionOrderWithId: state.ConstructionOrderReducer.isFetchingConstructionOrderWithId,
    constructionOrderWithIdData: state.ConstructionOrderReducer.constructionOrderWithIdData,
    isFetchingProduct: state.ProductReducer.isFetchingProduct,
    productDataList: state.ProductReducer.productDataList,
    isFetchingExpenseByOrderCategory: state.ExpenseReducer.isFetchingExpenseByOrderCategory,
    expenseByOrderCategoryData: state.ExpenseReducer.expenseByOrderCategoryData,
});
export default connect(mapStateToProps, mapDispatchToProps)(AddExpense);